import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColumn = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M15.75 3.09998H8.25V20.9H15.75V3.09998Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.25 3.59998H4.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.94995 9.09998H3.94995",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.94995 15.1H3.94995",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.25 20.7999H4.25",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.75 7.09998V8.29997",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.75 15.7999V17.2999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.75 11.2999V12.7999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 7.09998V8.29997",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 15.7999V17.2999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M23.25 11.2999V12.7999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.95 3.99997C0.839543 3.99997 0.75 3.91043 0.75 3.79997C0.75 3.68952 0.839543 3.59998 0.95 3.59998",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.949951 3.99997C1.06041 3.99997 1.14995 3.91043 1.14995 3.79997C1.14995 3.68952 1.06041 3.59998 0.949951 3.59998",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.95 20.7999C0.839543 20.7999 0.75 20.7104 0.75 20.5999C0.75 20.4894 0.839543 20.3999 0.95 20.3999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.949951 20.7999C1.06041 20.7999 1.14995 20.7104 1.14995 20.5999C1.14995 20.4894 1.06041 20.3999 0.949951 20.3999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.95 3.99997C22.8395 3.99997 22.75 3.91043 22.75 3.79997C22.75 3.68952 22.8395 3.59998 22.95 3.59998",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.95 3.99997C23.0605 3.99997 23.15 3.91043 23.15 3.79997C23.15 3.68952 23.0605 3.59998 22.95 3.59998",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.95 20.7999C22.8395 20.7999 22.75 20.7104 22.75 20.5999C22.75 20.4894 22.8395 20.3999 22.95 20.3999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.95 20.7999C23.0605 20.7999 23.15 20.7104 23.15 20.5999C23.15 20.4894 23.0605 20.3999 22.95 20.3999",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.75 3.59998H19.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.75 20.7999H19.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.25 9.09998H15.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.25 15.1H15.75",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.95 9.09998H19.95",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.95 15.1H19.95",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgColumn;
